import {
  suggestStoreName as suggestStoreNameHttp,
  createSitelessMetasite as createSitelessMetasiteHttp,
  attachSiteToMetasite as attachSiteToMetasiteHttp,
  updateSiteSettings as updateSiteSettingsHttp,
  createSiteFromTemplate as createSiteFromTemplateHttp,
  deleteAllProducts as deleteAllProductsHttp,
  addProductsToSiteCatalog as addProductsToSiteCatalogHttp,
} from '@wix/ambassador-gg-store-setup-v1-store-setup-service/http';
import {
  AttachSiteToMetasiteRequest,
  CreateSitelessMetasiteRequest,
  SuggestStoreNameRequest,
  UpdateSiteSettingsRequest,
  CreateSiteFromTemplateRequest,
  DeleteAllProductsRequest,
  AddProductsToSiteCatalogRequest,
} from '@wix/ambassador-gg-store-setup-v1-store-setup-service/types';
import { ENDPOINTS } from 'config/endpoints';
import {
  GenerateProductImagesHandlerRequest,
  GenerateProductImagesHandlerResponse,
} from 'server/handlers/generateProductImages';
import {
  GenerateProductProfileHandlerRequest,
  GenerateProductProfileHandlerResponse,
} from 'server/handlers/generateProductProfile';
import { InstallSiteAppsHandlerRequest, InstallSiteAppsHandlerResponse } from 'server/handlers/installSiteApps';
import {
  MatchProductCategoryHandlerRequest,
  MatchProductCategoryHandlerResponse,
} from 'server/handlers/matchProductCategory';
import { httpUtils } from 'utils/http';

const suggestSiteNames = async (params: SuggestStoreNameRequest) => {
  const response = await httpUtils.ambassador.request(suggestStoreNameHttp(params));
  return response.data;
};

const createSitelessMetasite = async (params: CreateSitelessMetasiteRequest) => {
  const response = await httpUtils.ambassador.request(createSitelessMetasiteHttp(params));
  return response.data;
};

const attachSiteToMetasite = async (params: AttachSiteToMetasiteRequest) => {
  const response = await httpUtils.ambassador.request(attachSiteToMetasiteHttp(params));
  return response.data;
};

const installSiteApps = async (params: InstallSiteAppsHandlerRequest) => {
  const response = await httpUtils.client.post<InstallSiteAppsHandlerResponse>(ENDPOINTS.INSTALL_SITE_APPS, params);
  return response.data;
};

const updateSiteSettings = async (params: UpdateSiteSettingsRequest) => {
  const response = await httpUtils.ambassador.request(updateSiteSettingsHttp(params));
  return response.data;
};

const createSiteFromTemplate = async (params: CreateSiteFromTemplateRequest) => {
  const response = await httpUtils.ambassador.request(createSiteFromTemplateHttp(params));
  return response.data;
};

const generateProductProfile = async (params: GenerateProductProfileHandlerRequest) => {
  const response = await httpUtils.client.post<GenerateProductProfileHandlerResponse>(
    ENDPOINTS.GENERATE_PRODUCT_PROFILE,
    params,
  );
  return response.data;
};

const generateProductImages = async (params: GenerateProductImagesHandlerRequest) => {
  const response = await httpUtils.client.post<GenerateProductImagesHandlerResponse>(
    ENDPOINTS.GENERATE_PRODUCT_IMAGES,
    params,
  );
  return response.data;
};

const emptyStoreCatalog = async (params: DeleteAllProductsRequest) => {
  const response = await httpUtils.ambassador.request(deleteAllProductsHttp(params));
  return response.data;
};

const addProductsToSiteCatalog = async (params: AddProductsToSiteCatalogRequest) => {
  const response = await httpUtils.ambassador.request(addProductsToSiteCatalogHttp(params));
  if (response.data.failureCount === params.products.length) {
    throw new Error('Failed to add products to site catalog');
  }
  return response.data;
};

const matchProductCategory = async (params: MatchProductCategoryHandlerRequest) => {
  const response = await httpUtils.client.post<MatchProductCategoryHandlerResponse>(
    ENDPOINTS.MATCH_PRODUCT_CATEGORY,
    params,
  );
  return response.data;
};

export const endpoints = {
  suggestSiteNames,
  createSitelessMetasite,
  attachSiteToMetasite,
  installSiteApps,
  updateSiteSettings,
  createSiteFromTemplate,
  generateProductProfile,
  generateProductImages,
  emptyStoreCatalog,
  addProductsToSiteCatalog,
  matchProductCategory,
};
